import { PII_FIELDS } from '@globals/personalIdentifierInfo/pIISanitizeUtils'
import { Provider } from '@rollbar/react'
import { FC, ReactNode } from 'react'
import Rollbar, { Configuration } from 'rollbar'
import { envConfig } from './globals/env'
import { transformRollbarPayload } from './rollbarProviderUtils'

type RollbarProviderProps = {
  children: ReactNode
}

const ENV: string = envConfig.DEPLOY_ENVIRONMENT
const ROLLBAR_ACCESS_TOKEN: string = envConfig.ROLLBAR_SDK_ID
const APP_VERSION: string = envConfig.APP_VERSION

const RollBarProvider: FC<RollbarProviderProps> = ({ children }) => {
  const rollbarConfig: Configuration = {
    accessToken: ROLLBAR_ACCESS_TOKEN,
    environment: ENV,
    captureUncaught: true,
    captureUnhandledRejections: false,
    reportLevel: 'warning',
    scrubFields: [...PII_FIELDS],
    // IMPORTANT needed so that default scrub fields from rollbar
    // remain scrubbed
    overwriteScrubFields: false,
    transform: transformRollbarPayload,
    payload: {
      client: {
        javascript: {
          code_version: APP_VERSION,
          source_map_enabled: true,
          guess_uncaught_frames: true,
        },
      },
    },
  }

  const rollbar = new Rollbar(rollbarConfig)
  return <Provider instance={rollbar}>{children}</Provider>
}

export default RollBarProvider
